module.exports = __webpack_public_path__ + "static/media/p2008girl.3a3469e0.jpg";